import React from "react";
import PracticeBankAccountService from "../../Services/PracticeBankAccountService";
import { Col, Form, Input, Row } from "antd";
import { Utils } from "../../Utilities/Utils";
import { adminContext } from "../../Common/PageRoute";
import { AppDrawer } from "../../Common/Layout";

interface BankDetailsProps {
  practiceId: number;
  recordId?: string | any;
  // onDismiss: (data?: boolean) => void;
  onDismiss: (data?: { isUpdated: boolean; isPrimary?: boolean }) => void;
}

export const AddPracticeBank = ({
  practiceId,
  recordId,
  onDismiss,
}: BankDetailsProps) => {
  const [form] = Form.useForm();
  const { openNotification } = React.useContext(adminContext);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (recordId) {
      setLoading(true);
      const getBankDetails = async () => {
        await PracticeBankAccountService.get(recordId).then((res) => {
          if (res) {
            form.setFieldsValue(res);
            setLoading(false);
          } else {
            setLoading(false);
            openNotification("error", res?.message);
          }
        });
      };
      getBankDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordId]);

  const handleSubmit = async () => {
    try {
      const value = await form.validateFields();
      setLoading(true);
      const payload = { ...value, practiceId };
      const res = await PracticeBankAccountService.create(recordId, payload);
      if (res?.status) {
        setLoading(false);
        onDismiss({
          isUpdated: true,
          isPrimary: res?.result?.primary,
        });
        openNotification("success", "Bank details added successfully.");
      } else {
        setLoading(false);
        openNotification("error", res?.message);
      }
    } catch {
      setLoading(false);
    }
  };

  return (
    <AppDrawer
      title={recordId ? "Edit Bank Details" : "Add Bank Details"}
      open={true}
      onClose={() => onDismiss()}
      onSave={handleSubmit}
      loading={loading}
      width={480}
      saveText="Save"
      cancelText="Cancel"
    >
      <Form form={form} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label="Account name"
              className="custom-form-item"
              colon={false}
              labelCol={{ span: 10 }}
              style={{ textAlignLast: "left" }}
              name="accountName"
              rules={[
                { required: true, message: "Enter account name" },
                { validator: Utils.validateWhiteSpace },
              ]}
            >
              <Input className="line-height-28" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label="Bank name"
              className="custom-form-item"
              colon={false}
              labelCol={{ span: 10 }}
              style={{ textAlignLast: "left" }}
              name="bankName"
              rules={[
                { required: true, message: "Enter bank name" },
                { validator: Utils.validateWhiteSpace },
              ]}
            >
              <Input className="line-height-28" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label="Account number"
              className="custom-form-item"
              colon={false}
              labelCol={{ span: 10 }}
              style={{ textAlignLast: "left" }}
              name="accountNumber"
              rules={[{ required: true, message: "Enter account number" }]}
            >
              <Input
                className="line-height-28"
                onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label="Sort code"
              className="custom-form-item"
              colon={false}
              labelCol={{ span: 10 }}
              style={{ textAlignLast: "left" }}
              name="shortCode"
            >
              <Input
                className="line-height-28"
                onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label="IBAN"
              className="custom-form-item"
              colon={false}
              labelCol={{ span: 10 }}
              style={{ textAlignLast: "left" }}
              name="iban"
            >
              <Input className="line-height-28" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label="BIC code"
              className="custom-form-item"
              colon={false}
              labelCol={{ span: 10 }}
              style={{ textAlignLast: "left" }}
              name="bik"
            >
              <Input className="line-height-28" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </AppDrawer>
  );
};
